var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighSpeedLowCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.205 102.51L140.788 247.731C139.141 250.936 137.11 253.576 134.696 255.674C132.281 257.75 129.935 258.833 127.678 258.946C126.731 258.991 125.851 258.856 125.084 258.54C125.084 258.54 124.993 258.494 124.79 258.404C124.677 258.337 124.497 258.246 124.294 258.156C124.181 258.088 124.045 258.021 123.887 257.93C123.323 257.547 122.804 257.05 122.353 256.419C121.089 254.659 120.593 252.222 120.887 249.108L128.129 187.554L109.379 198.385L100.082 203.755C97.6679 205.154 95.66 205.492 94.103 204.703L93.7192 204.499C93.0874 204.138 92.5235 203.552 92.0497 202.807C90.3123 200.099 90.5153 196.399 92.6138 191.706L143.654 78.0728L160.261 41.0677C161.75 37.7733 163.713 34.9528 166.128 32.6061C168.542 30.2595 171.024 28.8605 173.596 28.4318C174.86 28.2061 175.965 28.2738 176.913 28.6123L177.455 28.8831C178.177 29.2441 178.764 29.8308 179.26 30.5979C180.456 32.5159 180.907 35.0205 180.614 38.1343L177.41 69.7015L173.371 109.527L208.435 89.2872C210.782 87.9333 212.723 87.5272 214.234 88.0913L214.663 88.3169C215.475 88.7231 216.152 89.4451 216.694 90.4831C218.273 93.5518 217.777 97.5682 215.205 102.51Z",
    stroke: "url(#paint0_linear_2501_1420)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.888 257.93C117.118 254.523 83.8589 237.758 80.0456 236.021C79.9779 236.021 79.9104 235.975 79.8653 235.953C79.7525 235.908 79.7071 235.885 79.6846 235.885C78.7143 235.479 77.902 234.802 77.2251 233.854C75.9615 232.094 75.4653 229.657 75.7586 226.544L79.2107 197.234L93.7194 204.499L94.1033 204.702C95.6602 205.492 97.6682 205.154 100.083 203.755L109.379 198.384L128.13 187.554L120.887 249.108C120.594 252.222 121.09 254.658 122.353 256.418C122.805 257.05 123.324 257.547 123.888 257.93Z",
    stroke: "url(#paint1_linear_2501_1420)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.913 28.6121C175.966 28.2736 174.86 28.206 173.597 28.4316C171.024 28.8603 168.542 30.2593 166.128 32.606C163.714 34.9526 161.751 37.7731 160.261 41.0675L143.654 78.0726L92.6142 191.705C90.5157 196.399 90.3127 200.099 92.0501 202.807C92.5239 203.552 93.0878 204.138 93.7196 204.499L79.2109 197.234L49.5167 182.364C48.5013 182.071 47.6438 181.349 46.9218 180.243C45.1843 177.535 45.3874 173.835 47.4859 169.141L115.133 18.5033C116.622 15.2089 118.585 12.3884 121 10.0418C123.414 7.69511 125.896 6.29614 128.469 5.86742C129.958 5.61922 131.221 5.73201 132.237 6.25099H132.259L176.913 28.6121Z",
    stroke: "url(#paint2_linear_2501_1420)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.235 88.0912C212.723 87.5271 210.782 87.9332 208.436 89.2871L173.371 109.527L177.41 69.7014L214.235 88.0912Z",
    stroke: "url(#paint3_linear_2501_1420)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.455 28.8828L176.913 28.6121",
    stroke: "url(#paint4_linear_2501_1420)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_1420",
    x1: 154.237,
    y1: 28.3003,
    x2: 154.237,
    y2: 258.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_1420",
    x1: 101.903,
    y1: 187.554,
    x2: 101.903,
    y2: 257.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_1420",
    x1: 111.332,
    y1: 5.74121,
    x2: 111.332,
    y2: 204.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2501_1420",
    x1: 193.803,
    y1: 69.7014,
    x2: 193.803,
    y2: 109.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2501_1420",
    x1: 177.184,
    y1: 28.6121,
    x2: 177.184,
    y2: 28.8828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighSpeedLowCost);
export default __webpack_public_path__ + "static/media/High-Speed-Low-Cost.bea3a6d067492929a3690ef9b171aecd.svg";
export { ForwardRef as ReactComponent };